import styled from 'styled-components';

export const StaticBannerWithImageStyled = styled.div`
  margin: 16px 0px;

  .banner {
    width: 100%;
    margin: 0 0 20px 0;
    position: relative;
    cursor: pointer;

    .timerBannerStyle {
      position: absolute !important;
      top: 220px;
      left: 50px;
    }

    & > div {
      position: relative !important;

      & > img {
        position: relative !important;
        width: 100% !important;
        height: 100% !important;
        border-radius: 8px;
      }
    }
    .content {
      display: inline-flex;
      flex-direction: column;
      margin: 80px 0 0 100px;

      .line {
        color: ${(props) => props.theme.color.white};
        font-size: 24px;
        font-weight: 700;
        margin: 0;
        line-height: 1;
      }

      button {
        font-weight: 700;
        color: ${(props) => props.theme.text.medium};
        background: ${(props) => props.theme.color.white};
        border-color: ${(props) => props.theme.color.white};
        box-shadow: 0 4px 12px 0 ${(props) => props.theme.blue.dark}12;
        margin: 20px 0 0 0;
        padding: 18px 30px;

        &:hover {
          color: ${(props) => props.theme.color.white};
          background: ${(props) => props.theme.blue.dark};
          border-color: ${(props) => props.theme.blue.dark};
          box-shadow: 0 4px 12px 0 ${(props) => props.theme.blue.dark}12;
        }
      }
    }
  }

  @media (max-width: 820px) {
    padding: 0 16px 16px 16px;

    .titleBar {
      .title {
        margin: 0;
      }
    }
    .banner {
      .content {
        .line {
          font-size: 18px;
        }
        button {
          padding: 10px 15px;
          font-size: 14px;
        }
      }
    }
  }

  @media (max-width: 480px) {
    padding: 0 16px;
    margin: 0 0 16px 0;
  }
`;
